module.exports = __webpack_public_path__ + "static/img/weather-bg-8.5991e9e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-bg-8.gif
// module id = Xnow
// module chunks = 1